export default __webpack_public_path__ + "static/media/pga-signature.ae99d1bc.png";